import React, { useEffect, useState } from "react";
import RelatorioForm from "../../components/Relatorios/gerarGarantia";
import RelatorioGarantia from "../../components/Relatorios/relatorioGarantia";
import { getRelatorioAplicacoesGarantia } from "../../services/api_relatorio_aplicacao_garantia";
import Swal from "sweetalert2";

const RelatorioPage = (props) => {
  const [showForm, setShowForm] = useState(true);
  const [showRelatorio, setShowRelatorio] = useState(false);
  const [filtro, setFiltro] = useState({});
  const [dadosRelatorio, setDadosRelatorio] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (loading) {
      Swal.fire({
        title: "Gerando relatório...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
    } else {
      Swal.close();
    }
  }, [loading]);

  // RelatorioPage.jsx
  // Certifique-se de que os dados estão sendo combinados corretamente e definidos como estado para serem passados ao componente Relatorio

  const handleGenerateRelatorio = async (filtro) => {
    try {
      setLoading(true);
      let body = {
        idEmpresa: filtro.empresa,
        idUnidade: filtro.unidade,
        idTipoAplicacao: filtro.tipoAplicacao,
      };
      // Combine os dados de diferentes fontes em um único array
      const dados = await getRelatorioAplicacoesGarantia(body);

      console.log("eita:", dados);

      setFiltro({
        nomeEmpresa: filtro.nomeEmpresa,
        nomeUnidade: filtro.nomeUnidade,
        descricaoTipoAplicacao: filtro.descricaoTipoAplicacao,
        garantia: filtro.garantia,
      });
      setDadosRelatorio(dados);
      setShowForm(false);
      setShowRelatorio(true);
      setLoading(false);

      console.log(dadosRelatorio);
    } catch (error) {
      console.error("Erro ao gerar relatório:", error);
    }
  };

  return (
    <div>
      {showForm && (
        <RelatorioForm
          show={showForm}
          handleClose={() => setShowForm(false)}
          handleGenerate={handleGenerateRelatorio}
        />
      )}
      {showRelatorio && (
        <RelatorioGarantia
          filtro={filtro}
          dataHora={new Date().toLocaleString()}
          dados={dadosRelatorio}
          setShowForm={setShowForm} // Passa a função para mostrar o formulário
          setShowRelatorio={setShowRelatorio} // Passa a função para esconder o relatório
        />
      )}
    </div>
  );
};

export default RelatorioPage;
